/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Grower_Bank_NameInputs */

const vi_grower_bank_name = /** @type {(inputs: Grower_Bank_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ngân hàng`)
};

/**

* @param {Grower_Bank_NameInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const grower_bank_name = /** @type {((inputs?: Grower_Bank_NameInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Grower_Bank_NameInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_grower_bank_name(inputs)
});